/**
 * Sprint G — Founding Customer offer letter (client-side embed).
 * Source of truth: /app/memory/design_partner_offer.md. Keep in sync.
 */

export const FOUNDING_CUSTOMER_LETTER = `Subject: Founding-customer access to Nexus One — 50% off forever

Hi {{first_name}},

Following up on our conversation — I want to make you one of our founding customers.

Nexus One is the AI Workforce Operating System I've built: 22 Workforce Members you can hire on demand (Legal Assistant, Data Analyst, Recruiter, Executive Assistant, Customer Support, Content Writer, CFO, COO, Marketing Director, Sales Manager, HR Director, Engineering, and more). Each one has real character, credentials, and expertise — and lives inside the tools you already use.

What you get as a founding customer:
- 50% off list price forever — locked in from the day you say yes, not just year one
- Immediate access today — I'll send you a VIP lifetime code that unlocks the full platform, no billing required. Use it, break things, tell me what you need.
- Direct roadmap influence — your feedback goes straight to what we build next
- Seamless migration to your paid plan at GA (~4-6 weeks) — no gap, no disruption

What's ready today:
- Chat with all 22 AI specialists — real Claude Sonnet 4.5 powered
- Documents, Email, Meetings, Knowledge workspaces — fully functional
- Multi-tenant secure workspace for your team
- Multi-integration Connectors + ROI dashboard + Home command center

What's coming in the next 4-6 weeks:
- Real Stripe billing (VIP code covers it in the meantime)
- 600+ real integrations across every category
- AI Legal Department vertical — 18 specialized legal agents with matter management, ethical walls, and attorney-supervision gates
- Custom Skill Builder + Agent-to-Agent orchestration

Zero-risk terms:
- Cancel anytime, no contracts required
- Your data exports on-demand in standard formats
- No lock-in
- If we don't hit our roadmap commitments to your satisfaction, we refund proactively

Ready to try it? Reply and I'll send your VIP code within the hour. Founding-customer spots are limited to 10 companies total. First-come, first-served.

Preview: ${process.env.REACT_APP_PUBLIC_URL || process.env.REACT_APP_BACKEND_URL || 'https://nexusone.ai'}

Talk soon,
Dr. Bryce Askew
Founder, Nexus One
founder@nexus-one.com
`;
